import { Component, Directive, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@Directive({ selector: '[uwTwoColumnMicroLayoutRight]' })
export class TwoColumnMicroLayoutRightDirective { }

@Directive({ selector: '[uwTwoColumnMicroLayoutLeft]' })
export class TwoColumnMicroLayoutLeftDirective { }


@Component({
    selector: 'uw-two-column-micro-layout',
    templateUrl: './two-column-micro-layout.component.html',
    styleUrls: ['./two-column-micro-layout.component.scss']
})
export class TwoColumnMicroLayoutComponent {

}

@NgModule({
    exports: [
        TwoColumnMicroLayoutComponent,
        TwoColumnMicroLayoutLeftDirective,
        TwoColumnMicroLayoutRightDirective
    ],
    imports: [
        CommonModule,
        TwoColumnMicroLayoutComponent,
        TwoColumnMicroLayoutLeftDirective,
        TwoColumnMicroLayoutRightDirective
    ]
})
export class TwoColumnMicroLayoutModule { }
